"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isProduction = isProduction;
exports.isProductionEnvironment = isProductionEnvironment;

/**
 * Export `isProduction`.
 */
function isProduction() {
  return process.env.NODE_ENV === 'production'; // eslint-disable-line no-process-env
}
/**
 * Export `isProductionEnvironment`.
 */


function isProductionEnvironment() {
  return process.env.NODE_CONFIG_ENV === 'prd'; // eslint-disable-line no-process-env
}